import { useState } from 'react';

import {
   DEFAULT_ELEVENLABS_CONFIG,
   DEFAULT_ELEVENLABS_DIARIZATION_CONFIG,
   ElevenLabsTranscriptionConfig,
} from './ElevenLabsTranscriptionConfig';

export type UseTranscriptionConfigResult = {
   dictationConfig: ElevenLabsTranscriptionConfig;
   continuousConfig: ElevenLabsTranscriptionConfig;
   setDictationConfig: (config: ElevenLabsTranscriptionConfig) => void;
   setContinuousConfig: (config: ElevenLabsTranscriptionConfig) => void;
};

/**
 * Holds separate config for dictation and continuous (diarization) modes.
 * Defaults: dictation uses standard settings, continuous disables audio processing
 * to preserve speaker characteristics for diarization.
 */
export const useTranscriptionConfig = (): UseTranscriptionConfigResult => {
   const [dictationConfig, setDictationConfig] = useState<ElevenLabsTranscriptionConfig>(DEFAULT_ELEVENLABS_CONFIG);
   const [continuousConfig, setContinuousConfig] = useState<ElevenLabsTranscriptionConfig>(
      DEFAULT_ELEVENLABS_DIARIZATION_CONFIG
   );

   return {
      dictationConfig: dictationConfig,
      continuousConfig: continuousConfig,
      setDictationConfig: setDictationConfig,
      setContinuousConfig: setContinuousConfig,
   };
};
